import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class ChequeDepositListingService {
  constructor(private http: HttpUtilService) {}

  GetReceipts(receiptDate: string): Observable<any> {
    const encodedReceiptDate = encodeURIComponent(`"${receiptDate}"`);
    const url = `ChequeIssueService.asmx/GetReceipts?receiptDate=${encodedReceiptDate}`;
    return this.http.get(url);
  }

  print(model: any): Observable<any> {
    return this.http.post("ChequeIssueService.asmx/Print", {
      model,
    });
  }

  export(model: any): Observable<any> {
    return this.http.post("ChequeIssueService.asmx/Export", {
      model,
    });
  }
}
